//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Weeks
//   Details:    Weeks store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103563 18/09/19 JHT M01  Variable styling (traffic lights)
// WI4743 24/02/25 JC  M02JC	Added IsWorking to days
//-------------------------------------------------------

import { fetchActions } from "../FetchWrapper";
import { userActions } from './Authentication';
import moment from 'moment';

const weeksRequestType = 'WEEKS_REQUEST';
const weeksSuccessType = 'WEEKS_SUCCESS';
const weeksFailureType = 'WEEKS_FAILURE';
var epCalendarStyle; //M01

const stateLookup = [
	"",
	"Holiday used",
	"Holiday pending",
	"Holiday approved",
	"Holiday rejected",
	"Absence used",
	"Absence pending",
	"Absence approved",
	"Absence rejected"
];

//M01
const stateLookup_tl = [
    "",
    "Holiday_tl used_tl",
    "Holiday_tl pending_tl",
    "Holiday_tl approved_tl",
    "Holiday_tl rejected_tl",
    "Absence_tl used_tl",
    "Absence_tl pending_tl",
    "Absence_tl approved_tl",
    "Absence_tl rejected_tl"
];


const initialState = {
	weeks: [],
	siteId: undefined,
	month: 0,
	year: 0,
	isLoading: false,
	canRequest: true,
	error: undefined
};

export const weeksActions = {
    getWeeks
    , getClassForStateSample //M01
};


// --------------------------------------------------------------
//M01 get class for given state (sample)
function getClassForStateSample(dayState) {
    return (dispatch) => {
        return getClassForState(dayState);
    };
}

// --------------------------------------------------------------
//M01 get class for given state
function getClassForState(dayState) {
        if (epCalendarStyle === "trafficlights") {
            return stateLookup_tl[dayState];
        }
        return stateLookup[dayState];
}

function getWeeks(siteId, year, month) {
	return (dispatch, getState) => {

		if (!getState().clientConfiguration.isLoaded)
			return;

		if (!getState().clientConfiguration.config.endpoint && !getState().authentication.user)
			return;

		dispatch(_request());

		const yearMonth = formatYearMonth(year, month);

		const url = getState().clientConfiguration.config.endpoint + "/weeks";
		const query = `?siteId=${siteId}&yearMonth=${encodeURIComponent(yearMonth)}`;
        const ticket = getState().authentication.user.ticket;

        epCalendarStyle = getState().clientConfiguration.config.calendarstyle; //M01


		fetchActions.get(url + query, ticket)
			.then(
				response => {
					const weeks = mapWeeks(response.data);
					let startDate;

					if (weeks.length !== 0) {
						startDate = moment(weeks[0].weekStartDate);
						startDate.add(7, "days");
					} else {
						startDate = moment();
					}

					dispatch(_success(weeks, siteId, startDate.month() + 1, startDate.year()));
				},
				error => {
					if (error.sessionExpired) {
						dispatch(userActions.sessionExpired());
					}
					else {
						var message = `Could not get calendar information: ${error.message}`;
						dispatch(_failure(message));
					}
				}
			);
	};

	function formatYearMonth(year, month) {
		if (!year || !month)
			return 0;

		return "" + year + (month < 10 ? "0" + month : month);
	}

	function mapWeeks(weeks) {
		if (weeks.length !== 0) {
			const weekStart = moment(weeks[0].weekStartDate);
			const actualMonth = weekStart.add(7, "days").month();
			const today = moment();

			return weeks.map((week, i) => {
				const date = moment(week.weekStartDate);

				var days = [];

				days.push({
					date: date.clone().format(),
					state: week.monState,
                    stateClass: getClassForState(week.monState),
                    stateText: stateLookup[week.monState],
					requestId: week.monRequestId || 0,
					isInMonth: date.month() === actualMonth,
					isToday: date.isSame(today, 'day'),
					isWorking: week.monWorkingDay //M02JC
				});

				date.add(1, "days");

				days.push({
					date: date.clone().format(),
					state: week.tueState,
                    stateClass: getClassForState(week.tueState),
                    stateText: stateLookup[week.tueState],
					requestId: week.tueRequestId || 0,
					isInMonth: date.month() === actualMonth,
					isToday: date.isSame(today, 'day'),
					isWorking: week.tueWorkingDay //M02JC
				});

				date.add(1, "days");

				days.push({
					date: date.clone().format(),
					state: week.wedState,
                    stateClass: getClassForState(week.wedState),
                    stateText: stateLookup[week.wedState],
					requestId: week.wedRequestId || 0,
					isInMonth: date.month() === actualMonth,
					isToday: date.isSame(today, 'day'),
					isWorking: week.wedWorkingDay //M02JC
				});

				date.add(1, "days");

				days.push({
					date: date.clone().format(),
					state: week.thuState,
                    stateClass: getClassForState(week.thuState),
                    stateText: stateLookup[week.thuState],
					requestId: week.thuRequestId || 0,
					isInMonth: date.month() === actualMonth,
					isToday: date.isSame(today, 'day'),
					isWorking: week.thuWorkingDay //M02JC
				});

				date.add(1, "days");

				days.push({
					date: date.clone().format(),
					state: week.friState,
                    stateClass: getClassForState(week.friState),
                    stateText: stateLookup[week.friState],
					requestId: week.friRequestId || 0,
					isInMonth: date.month() === actualMonth,
					isToday: date.isSame(today, 'day'),
					isWorking: week.friWorkingDay //M02JC
				});

				date.add(1, "days");

				days.push({
					date: date.clone().format(),
					state: week.satState,
                    stateClass: getClassForState(week.satState),
                    stateText: stateLookup[week.satState],
					requestId: week.satRequestId || 0,
					isInMonth: date.month() === actualMonth,
					isToday: date.isSame(today, 'day'),
					isWorking: week.satWorkingDay //M02JC
				});

				date.add(1, "days");

				days.push({
					date: date.clone().format(),
					state: week.sunState,
                    stateClass: getClassForState(week.sunState),
                    stateText: stateLookup[week.sunState],
					requestId: week.sunRequestId || 0,
					isInMonth: date.month() === actualMonth,
					isToday: date.isSame(today, 'day'),
					isWorking: week.sunWorkingDay //M02JC
				});

				return {
					weekStartDate: week.weekStartDate,
					weekNumber: week.weekNumber,
					days : days
				};
			});
		}
	}

	function _request() { return { type: weeksRequestType }; }
	function _success(weeks, siteId, month, year) { return { type: weeksSuccessType, weeks, siteId, month, year }; }
	function _failure(error) { return { type: weeksFailureType, error }; }
}


export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === weeksRequestType) {
		return { ...state, isLoading: true, canRequest: false };
	}

	if (action.type === weeksSuccessType) {
		return { ...state, isLoading: false, canRequest: true, weeks: action.weeks, siteId: action.siteId, month: action.month, year: action.year };
	}

	if (action.type === weeksFailureType) {
		return { ...state, isLoading: false, canRequest: true, error: action.error};
	}

	return state;
};